var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4.56L12.3086 0H11.6914L0 4.56V15.4286H1.71429V6.85714L5.67429 8.4C4.79953 9.64571 4.32694 11.1293 4.32 12.6514C4.30306 12.8396 4.30306 13.029 4.32 13.2171V13.4057L4.8 14.0914L11.6229 17.1429H12.3257L19.08 14.04L19.56 13.3543V13.1486C19.56 12.9771 19.56 12.7886 19.56 12.6C19.5503 11.0862 19.0843 9.61053 18.2229 8.36571L24 6.12V4.56ZM17.9657 12.5829V12.7029L12 15.4286L6 12.6857C5.99198 12.6519 5.99198 12.6167 6 12.5829C6.00933 11.2616 6.4621 9.98176 7.28571 8.94857L11.7086 10.6629H12.3257L16.7143 8.94857C17.5304 9.98365 17.9715 11.2648 17.9657 12.5829ZM12 9L2.60571 5.34857L12 1.71429L21.3943 5.38286L12 9Z",
    fill: "#564ECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapBlue);
export default __webpack_public_path__ + "static/media/CapBlue.25334df5c5d5e1c9fef700ecdd232113.svg";
export { ForwardRef as ReactComponent };